import { render, staticRenderFns } from "./ListaDoacoes.vue?vue&type=template&id=a8234960&scoped=true&"
import script from "./ListaDoacoes.vue?vue&type=script&lang=js&"
export * from "./ListaDoacoes.vue?vue&type=script&lang=js&"
import style0 from "./ListaDoacoes.vue?vue&type=style&index=0&id=a8234960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8234960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItem,VListItemContent,VListItemTitle,VRow})
